/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Suggestions_Prompt_3Inputs */

const es_chat_suggestions_prompt_3 = /** @type {(inputs: Chat_Suggestions_Prompt_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué reuniones tengo esta semana?`)
};

const en_chat_suggestions_prompt_3 = /** @type {(inputs: Chat_Suggestions_Prompt_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What meetings do I have this week?`)
};

/**
* | output |
* | --- |
* | "What meetings do I have this week?" |
*
* @param {Chat_Suggestions_Prompt_3Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_suggestions_prompt_3 = /** @type {((inputs?: Chat_Suggestions_Prompt_3Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Suggestions_Prompt_3Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_suggestions_prompt_3(inputs)
	return en_chat_suggestions_prompt_3(inputs)
});
export { chat_suggestions_prompt_3 as "chat.suggestions.prompt_3" }